// import React, { useEffect, useRef, useState } from "react";
// import { useLocation, useNavigate } from "react-router-dom";
// import jsPDF from "jspdf";
// import html2canvas from "html2canvas";
// import "./LoanEmiReciept.css";
// import { useDispatch, useSelector } from "react-redux";
// import { fetchUserProfile } from "../redux/slices/branch/userProfileSlice";

// import { fetchLoanEmis } from "../redux/slices/loan/loanEmiSlice";

// const Loanemireciept = () => {
//   const location = useLocation();
//   const navigate = useNavigate();
//   const { emi ,loanId ,nextemi,unusedAmount} = location.state ;
//   // console.log("emi is ",emi);

//   const receiptRef = useRef(null);
//   const thermalReceiptRef = useRef(null);

//   const { profile } = useSelector((state) => state.userProfile);
//    const { emis, customerName, loanNumber, count, loading, error } = useSelector(
//       (state) => state.loanEmi,
//     );

//   const dispatch = useDispatch();

//   const [company, setCompany] = useState(null);

//   // Fetch profile
//   useEffect(() => {
//     dispatch(fetchUserProfile());
//   }, [dispatch]);

//   useEffect(() => {
//     if (loanId) {
//       dispatch(fetchLoanEmis(loanId));
//     }
//   }, [loanId, dispatch]);

//   // Fetch company info
//   const fetchCompany = async () => {
//     try {
//       const res = await fetch(
//         `https://payyug.in/api/get-company?superAdminId=${profile?.superAdminId}`
//       );
//       const data = await res.json();
//       if (res.ok && data) {
//         if (data.logo) {
//           data.logoUrl = `https://payyug.in/${data.logo.replace(/^images\//, "")}`;
//         }
//         if (data.qrCodeImage) {
//           data.qrCodeUrl = `https://payyug.in/${data.qrCodeImage.replace(/^images\//, "")}`;
//         }
//         setCompany(data);
//       }
//     } catch (err) {
//       console.error("Error fetching company:", err);
//     }
//   };

//   useEffect(() => {
//     if (profile?.superAdminId) {
//       fetchCompany();
//     }
//   }, [profile?.superAdminId]);

//   const handlePrint = async () => {
//     if (!receiptRef.current) return;

//     const pdf = new jsPDF("p", "mm", "a4");

//     const canvas = await html2canvas(receiptRef.current, {
//       scale: 1.5,
//       useCORS: true,
//       backgroundColor: "#fff",
//     });

//     const imgData = canvas.toDataURL("image/jpeg", 0.9);
//     const pdfWidth = pdf.internal.pageSize.getWidth();
//     const imgHeight = (canvas.height * pdfWidth) / canvas.width;

//     pdf.addImage(imgData, "JPEG", 0, 0, pdfWidth, imgHeight);

//     const blobUrl = pdf.output("bloburl");
//     const iframe = document.createElement("iframe");
//     iframe.style.display = "none";
//     iframe.src = blobUrl;
//     document.body.appendChild(iframe);

//     iframe.onload = () => {
//       iframe.contentWindow.focus();
//       iframe.contentWindow.print();

//       window.addEventListener(
//         "focus",
//         () => {
//           setTimeout(() => {
//             if (document.body.contains(iframe)) {
//               document.body.removeChild(iframe);
//             }
//           }, 500);
//         },
//         { once: true }
//       );
//     };
//   };

//   const handlePrintThermalSlip = async () => {
//     if (!thermalReceiptRef.current) return;

//     try {
//       const iframe = document.createElement("iframe");
//       iframe.style.position = "fixed";
//       iframe.style.right = "0";
//       iframe.style.bottom = "0";
//       iframe.style.width = "0";
//       iframe.style.height = "0";
//       iframe.style.border = "0";
//       document.body.appendChild(iframe);

//       const doc = iframe.contentWindow.document;

//       doc.open();
//       doc.write(`
//         <html>
//           <head>
//             <style>
//               @page {
//                 size: 58mm auto;
//                 margin: 0;
//               }
//               body {
//                 margin: 0;
//                 padding: 0;
//                 display: flex;
//                 flex-direction: column;
//                 align-items: center;
//                 justify-content: flex-start;
//               }
//               img {
//                 width: 58mm;
//                 max-width: 58mm;
//                 margin: 0 auto;
//                 display: block;
//               }
//             </style>
//           </head>
//           <body></body>
//         </html>
//       `);
//       doc.close();

//       const canvas = await html2canvas(thermalReceiptRef.current, {
//         scale: 3,
//         backgroundColor: "#fff",
//         useCORS: true,
//       });

//       const imgData = canvas.toDataURL("image/png");
//       const img = doc.createElement("img");
//       img.src = imgData;

//       await new Promise((res) => (img.onload = res));
//       doc.body.appendChild(img);

//       setTimeout(() => {
//         iframe.contentWindow.focus();
//         iframe.contentWindow.print();
//         setTimeout(() => {
//           document.body.removeChild(iframe);
//         }, 1000);
//       }, 300);
//     } catch (err) {
//       console.error("Thermal printing failed", err);
//       alert("Thermal print failed");
//     }
//   };

//   // if (!account || !emi) {
//   //   return <div className="p-10 text-center">Receipt Data Not Found</div>;
//   // }

//   return (
//     <div className="receipt-viewer-container">
//       {/* Action Buttons */}
//       <div className="receipt-actions receipt-no-print">
//         <button onClick={() => navigate(-1)} className="receipt-back-btn">
//           Back
//         </button>
//         <button onClick={handlePrint} className="btn-print-receipt">
//           Print Receipt
//         </button>
//         <button
//           onClick={handlePrintThermalSlip}
//           className="btn-thermal-print-receipt"
//         >
//           Thermal Print Receipt
//         </button>
//       </div>

//       {/* Printable Receipt Design */}
//       <div
//         id="receipt-0"
//         style={{ pageBreakAfter: "always" }}
//         className="receipt-paper"
//         ref={receiptRef}
//       >
//         <div className="receipt-header-section">
//           <div className="receipt-header-company-section">
//             <div className="receipt-company-details">
//               <img
//                 src={company?.logoUrl}
//                 alt="logo"
//                 className="receipt-logo"
//               />
//               <div className="receipt-header-company-info">
//                 <h1>{company?.name || "N/A"}</h1>
//                 <p className="address">
//                   <b>Address: </b>
//                   {company?.address || "N/A"}
//                 </p>
//                 <p className="contact">
//                   <b>Phone:</b> {company?.contact || "N/A"}
//                 </p>
//                 <p className="contact">
//                   <b>Email:</b>{" "}{company?.email || "N/A"}
//                 </p>
//                 <p className="cin">
//                   <b>CIN:</b> {company?.cin || "N/A"}
//                 </p>
//               </div>
//             </div>
//           </div>

//           <div className="receipt-title-box">
//             <h2>COLLECTION RECEIPT</h2>
//             <p>
//               Receipt No: #{emi?.id || "905"} | Date:{" "}
//               {new Date(emi?.paymentDate || Date.now()).toLocaleDateString("en-GB")}
//             </p>
//           </div>
//         </div>

//         {/* Sections */}
//         <div className="receipt-section">
//           <h3 className="receipt-section-title">EMI Collection DETAILS</h3>
//           <div className="receipt-details-wrapper">
//             <div className="receipt-grid-item">
//               <span>Customer Name:</span>{" "}
//               <strong>{customerName || "N/A"}</strong>
//             </div>
//             <div className="receipt-grid-item">
//               <span>Loan Account Number:</span>{" "}
//               <strong>{loanNumber || "N/A"}</strong>
//             </div>
//             <div className="receipt-grid-item">
//               <span>Emi Number:</span>{" "}
//               <strong>{emi?.emiNumber || "N/A"}</strong>
//             </div>
//             <div className="receipt-grid-item">
//               <span>Emi Amount:</span>{" "}
//               <strong>{"₹" + (emi?.emiAmount?.toLocaleString() || "N/A")}</strong>
//             </div>
//               <div className="receipt-grid-item">
//               <span>Penalty Amount:</span>{" "}
//               <strong>{"₹" + (emi?.penaltyAmount?.toLocaleString() || "N/A")}</strong>
//             </div>

//             <div className="receipt-grid-item">
//               <span>Total Amount:</span>{" "}
//               <strong>{"₹" + ((emi?.emiAmount+emi?.penaltyAmount)?.toLocaleString() || "N/A")}</strong>
//             </div>

//             <div className="receipt-grid-item">
//               <span>OutStanding:</span>{" "}
//               <strong>{"₹" + ((emi?.outstanding)?.toLocaleString() || "N/A")}</strong>
//             </div>
//             <div className="receipt-grid-item">
//               <span>Advance Paid:</span>{" "}
//               <strong>{"₹" + ((unusedAmount)?.toLocaleString() || "N/A")}</strong>
//             </div>

//             {/* <div className="receipt-grid-item">
//               <span>Principal Amount:</span>{" "}
//               <strong>{"₹" + (emi?.principalComponent || "N/A")}</strong>
//             </div>
//             <div className="receipt-grid-item">
//               <span>Interest Rate:</span>{" "}
//               <strong>{"₹" + (emi?.interestComponent || "N/A")}</strong>
//             </div> */}
//             <div className="receipt-grid-item">
//               <span>Due Date:</span>{" "}
//               <strong>
//                 {emi?.dueDate
//                   ? new Date(emi.dueDate).toLocaleDateString("en-In")
//                   : "N/A"}
//               </strong>
//             </div>
//             <div className="receipt-grid-item due-date-special">
//               <span>Next Due Date:</span>{" "}
//               <strong>
//                 {nextemi?.dueDate
//                   ? new Date(nextemi.dueDate).toLocaleDateString("en-In")
//                   : "N/A"}
//               </strong>
//             </div>
//             <div className="receipt-grid-item">
//               <span>Paid Date:</span>{" "}
//               <strong>
//                 {emi.paymentDate
//                   ? new Date(emi.paymentDate).toLocaleDateString("en-In")
//                   : "N/A"}
//               </strong>
//             </div>
//             <div className="receipt-grid-item">
//               <span>Status:</span>{" "}
//               <strong>{emi?.status?.toUpperCase() || "N/A"}</strong>
//             </div>
//           </div>
//         </div>

//         {/* <table className="receipt-outstanding-table">
//           <tbody>
//             <tr className="receipt-outstanding-row">
//               <td>Outstanding Amount</td>
//               <td>
//                 ₹{" "}
//                 {Number(emi?.outstanding || 0).toLocaleString("en-IN", {
//                   minimumFractionDigits: 2,
//                 })}
//               </td>
//             </tr>
//           </tbody>
//         </table> */}

//         <div className="receipt-footer-signs">
//           <div className="receipt-sign-box">
//             <div className="receipt-sign-line"></div>
//             <p>Authorized Signatory</p>
//           </div>
//           <div className="receipt-sign-box">
//             <div className="receipt-sign-line"></div>
//             <p>Customer Signature</p>
//           </div>
//         </div>

//         <p className="receipt-system-gen-text">
//           This is a system-generated slip and does not require a signature.
//           <br />
//           For any queries, please contact us during business hours.
//         </p>
//       </div>

//       {/* Thermal print design */}
//       <div id="thermal-0" className="thermal-slip-wrapper">
//         <div ref={thermalReceiptRef} className="thermal-slip">
//           {/* COMPANY INFO */}
//           <div className="thermal-company">
//             <div className="thermal-company-name">
//               {company ? company.name : "--"}
//             </div>
//             <div className="thermal-company-text">
//               <b>Address:</b> {company ? company.address : "--"}
//             </div>
//             <div className="thermal-company-text">
//               <b>Phone:</b> {company ? company.contact : "--"} | <b>Email:</b>{" "}
//               {company ? company.email : "--"}
//             </div>
//             <div className="thermal-company-text">
//               <b>CIN:</b> {company ? company.cin : "--"}
//             </div>
//           </div>

//           {/* TITLE */}
//           <div className="thermal-title">EMI Collection Receipt</div>

//           <div className="thermal-divider"></div>

//           {/* DETAILS */}
//           <div className="thermal-row">
//             <b>Customer Name:</b> {customerName || "--"}
//           </div>
//           <div className="thermal-row">
//             <b>Account Number:</b> {loanNumber || "--"}
//           </div>
//           <div className="thermal-row">
//             <b>EMI Number:</b> {emi?.emiNumber || "--"}
//           </div>
//           <div className="thermal-row">
//             <b>EMI Amount:</b> {"₹" + (emi?.emiAmount || "--")}
//           </div>
//           <div className="thermal-row">
//             <b>Penalty Amount:</b> {"₹" + (emi?.penaltyAmount || "0")}
//           </div>
//           <div className="thermal-row">
//             <b>Total Amount:</b> {"₹" + (emi?.emiAmount+emi.penaltyAmount || "--")}
//           </div>
//           <div className="thermal-row">
//             <b>OutStanding:</b> {"₹" + (emi?.outstanding || "--")}
//           </div>
//           <div className="thermal-row">
//             <b>Advance Paid:</b> {"₹" + (unusedAmount || "--")}
//           </div>
//           <div className="thermal-row">
//             <b>Due Date :</b>{" "}
//             {emi?.dueDate
//               ? new Date(emi.dueDate).toLocaleDateString("en-In")
//               : "--"}
//           </div>
//           <div className="thermal-row">
//             <b>Next Due Date :</b>{" "}
//             {nextemi?.dueDate
//               ? new Date(nextemi.dueDate).toLocaleDateString("en-In")
//               : "--"}
//           </div>
//           <div className="thermal-row">
//             <b>Paid Date:</b>{" "}
//             {emi?.paymentDate
//               ? new Date(emi.paymentDate).toLocaleDateString("en-In")
//               : "--"}
//           </div>
//           <div className="thermal-row">
//             <b>Status:</b> {emi?.status || "--"}
//           </div>
//           {/* <div className="thermal-row">
//             <b>Outstanding Amount:</b> ₹ {emi?.outstanding || "--"}
//           </div> */}

//           <div className="thermal-divider"></div>

//           {/* FOOTER */}
//           <div className="thermal-footer">
//             <div>Thank you for your payment!</div>
//             <div>Computer Generated Receipt</div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Loanemireciept;



import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import "./LoanEmiReciept.css";
import { useDispatch, useSelector } from "react-redux";
import { fetchUserProfile } from "../redux/slices/branch/userProfileSlice";
import { fetchLoanEmis } from "../redux/slices/loan/loanEmiSlice";

const Loanemireciept = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { emi, loanId, nextemi, unusedAmount, remainingOutstanding } =
    location.state || {};

  const receiptRef = useRef(null);
  const thermalReceiptRef = useRef(null);

  const { profile } = useSelector((state) => state.userProfile);
  const { customerName, loanNumber } = useSelector((state) => state.loanEmi);

  const dispatch = useDispatch();
  const [company, setCompany] = useState(null);

  useEffect(() => {
    dispatch(fetchUserProfile());
  }, [dispatch]);

  useEffect(() => {
    if (loanId) {
      dispatch(fetchLoanEmis(loanId));
    }
  }, [loanId, dispatch]);

  const fetchCompany = async () => {
    try {
      const res = await fetch(
        `https://payyug.in/api/get-company?superAdminId=${profile?.superAdminId}`,
      );
      const data = await res.json();
      if (res.ok && data) {
        if (data.logo) {
          data.logoUrl = `https://payyug.in/${data.logo.replace(/^images\//, "")}`;
        }
        if (data.qrCodeImage) {
          data.qrCodeUrl = `https://payyug.in/${data.qrCodeImage.replace(/^images\//, "")}`;
        }
        setCompany(data);
      }
    } catch (err) {
      console.error("Error fetching company:", err);
    }
  };

  useEffect(() => {
    if (profile?.superAdminId) {
      fetchCompany();
    }
  }, [profile?.superAdminId]);

  // प्रिंट फंक्शन्स
  const handlePrint = async () => {
    if (!receiptRef.current) return;
    const pdf = new jsPDF("p", "mm", "a4");
    const canvas = await html2canvas(receiptRef.current, {
      scale: 1.5,
      useCORS: true,
      backgroundColor: "#fff",
    });

    const imgData = canvas.toDataURL("image/jpeg", 0.9);
    const pdfWidth = pdf.internal.pageSize.getWidth();
    const imgHeight = (canvas.height * pdfWidth) / canvas.width;

    pdf.addImage(imgData, "JPEG", 0, 0, pdfWidth, imgHeight);
    const blobUrl = pdf.output("bloburl");
    const iframe = document.createElement("iframe");
    iframe.style.display = "none";
    iframe.src = blobUrl;
    document.body.appendChild(iframe);

    iframe.onload = () => {
      iframe.contentWindow.focus();
      iframe.contentWindow.print();
      window.addEventListener(
        "focus",
        () => {
          setTimeout(() => {
            if (document.body.contains(iframe))
              document.body.removeChild(iframe);
          }, 500);
        },
        { once: true },
      );
    };
  };

  const handlePrintThermalSlip = async () => {
    if (!thermalReceiptRef.current) return;
    try {
      const iframe = document.createElement("iframe");
      iframe.style.position = "fixed";
      iframe.style.right = "0";
      iframe.style.bottom = "0";
      iframe.style.width = "0";
      iframe.style.height = "0";
      iframe.style.border = "0";
      document.body.appendChild(iframe);

      const doc = iframe.contentWindow.document;
      doc.open();
      doc.write(`
        <html>
          <head>
            <style>
              @page { size: 58mm auto; margin: 0; }
              body { margin: 0; padding: 0; display: flex; flex-direction: column; align-items: center; }
              img { width: 58mm; max-width: 58mm; margin: 0 auto; display: block; }
            </style>
          </head>
          <body></body>
        </html>
      `);
      doc.close();

      const canvas = await html2canvas(thermalReceiptRef.current, {
        scale: 3,
        backgroundColor: "#fff",
        useCORS: true,
      });

      const imgData = canvas.toDataURL("image/png");
      const img = doc.createElement("img");
      img.src = imgData;

      await new Promise((res) => (img.onload = res));
      doc.body.appendChild(img);

      setTimeout(() => {
        iframe.contentWindow.focus();
        iframe.contentWindow.print();
        setTimeout(() => {
          document.body.removeChild(iframe);
        }, 1000);
      }, 300);
    } catch (err) {
      console.error("Thermal printing failed", err);
      alert("Thermal print failed");
    }
  };

  if (!emi) {
    return <div className="p-10 text-center">Receipt Data Not Found</div>;
  }
  const isPartial = emi?.status?.toLowerCase()?.includes("partial");
 const advanceAmount = Number(unusedAmount || 0);

const isAdvance = advanceAmount > 0;

  const partialPaymentsHistory = [];
  let calculatedTotalPaid = 0;

  for (let i = 1; i <= 5; i++) {
    const amount = emi[`payment${i}`];
    const date = emi[`payment${i}Date`] || emi?.paidDate || emi?.lastPaidDate;
    const mode = emi[`payment${i}Mode`];
    if (amount !== null && amount !== undefined && amount > 0) {
      partialPaymentsHistory.push({ index: i, amount, date, mode });
      calculatedTotalPaid += Number(amount);
    }
  }

  const totalPaidTillDate =
    calculatedTotalPaid > 0
      ? calculatedTotalPaid
      : Number(emi?.paidAmount || 0);

  const receiptDate =
    emi?.paymentDate ||
    emi?.lastPaidDate ||
    emi?.updatedAt ||
    new Date().toISOString();

  const actualPenalty =
    Number(emi?.penaltyAmount === 0 ? emi?.penalty : emi?.penaltyAmount) || 0;

  const totalPayable = Number(emi?.emiAmount || 0) + actualPenalty;

  return (
    <div className="receipt-viewer-container">
      {/* Action Buttons */}
      <div className="receipt-actions receipt-no-print">
        <button onClick={() => navigate(-1)} className="receipt-back-btn">
          Back
        </button>
        <button onClick={handlePrint} className="btn-print-receipt">
          Print Receipt
        </button>
        <button
          onClick={handlePrintThermalSlip}
          className="btn-thermal-print-receipt"
        >
          Thermal Print Receipt
        </button>
      </div>

      {/* A4 Printable Receipt Design */}
      <div
        id="receipt-0"
        style={{ pageBreakAfter: "always" }}
        className="receipt-paper"
        ref={receiptRef}
      >
        <div className="receipt-header-section">
          <div className="receipt-header-company-section">
            <div className="receipt-company-details">
              {company?.logoUrl && (
                <img
                  src={company.logoUrl}
                  alt="logo"
                  className="receipt-logo"
                />
              )}
              <div className="receipt-header-company-info">
                <h1>{company?.name || "N/A"}</h1>
                <p className="address">
                  <b>Address: </b>
                  {company?.address || "N/A"}
                </p>
                <p className="contact">
                  <b>Phone:</b> {company?.contact || "N/A"} | <b>Email:</b>{" "}
                  {company?.email || "N/A"}
                </p>
                <p className="cin">
                  <b>CIN:</b> {company?.cin || "N/A"}
                </p>
              </div>
            </div>
          </div>

          <div className="receipt-title-box">
            <h2>COLLECTION RECEIPT</h2>
            <span className={`status-badge-top ${emi?.status}`}>
              {emi?.status?.toUpperCase()}
            </span>
            <p>
              Receipt No: #{emi?.id || "N/A"} | Date:{" "}
              {new Date(receiptDate).toLocaleDateString("en-GB")}
            </p>
          </div>
        </div>

        {/* Customer & Loan Section */}
        <div className="receipt-section">
          <h3 className="receipt-section-title">LOAN & CUSTOMER DETAILS</h3>
          <div className="receipt-details-wrapper text-dark-design">
            <div className="receipt-grid-item">
              <span>Customer Name:</span>{" "}
              <strong>{customerName || emi?.loan?.userName || "N/A"}</strong>
            </div>
            <div className="receipt-grid-item">
              <span>Loan Account Number:</span>{" "}
              <strong>
                {loanNumber || emi?.loan?.loanAccountNumber || "N/A"}
              </strong>
            </div>
            <div className="receipt-grid-item">
              <span>EMI Number:</span>{" "}
              <strong>{emi?.emiNumber || "N/A"}</strong>
            </div>
            <div className="receipt-grid-item">
              <span>Due Date:</span>{" "}
              <strong>
                {emi?.dueDate
                  ? new Date(emi.dueDate).toLocaleDateString("en-IN")
                  : "N/A"}
              </strong>
            </div>
          </div>
        </div>

        {/* Financial Summary Section */}
        <div className="receipt-section">
          <h3 className="receipt-section-title">FINANCIAL SUMMARY</h3>
          <div className="receipt-details-wrapper payment-summary-box">
            <div className="receipt-grid-item">
              <span>Standard EMI Amount:</span>{" "}
              <strong>₹{(emi?.emiAmount || 0).toLocaleString("en-IN")}</strong>
            </div>
            <div className="receipt-grid-item">
              <span>Penalty Charges:</span>{" "}
              <strong className="text-danger">
                ₹
                {emi?.penaltyAmount === 0
                  ? (emi?.penalty || 0).toLocaleString("en-IN")
                  : (emi?.penaltyAmount || 0).toLocaleString("en-IN")}
              </strong>
            </div>
            <div className="receipt-grid-item total-payable-row">
              <span>Total Payable for this EMI:</span>{" "}
              <strong>₹{totalPayable.toLocaleString("en-IN")}</strong>
            </div>

            {isPartial && (
              <>
            <div className="receipt-grid-item total-paid-highlight">
              <span>Total Paid Till Date:</span>{" "}
              <strong className="text-success">
                ₹{totalPaidTillDate.toLocaleString("en-IN")}
              </strong>
            </div>
              <div className="receipt-grid-item balance-highlight">
                <span>Remaining EMI Balance:</span>{" "}
                <strong className="text-warning">
                  ₹{(emi?.emiBalance || 0).toLocaleString("en-IN")}
                </strong>
              </div>
              </>
            )}

            {isAdvance && (
              <div className="receipt-grid-item advance-highlight">
                <span>Remaining Advance Amount:</span>{" "}
                <strong>₹{Number(unusedAmount).toLocaleString("en-IN")}</strong>
              </div>
            )}

            <div className="receipt-grid-item">
              <span>Remaining Outstanding Principal:</span>{" "}
              <strong>
                ₹{remainingOutstanding.toFixed(2) ?? emi?.outstanding.toFixed(2) ?? 0}
              </strong>
            </div>
            <div className="receipt-grid-item">
              <span>Next Due Date:</span>{" "}
              <strong className="text-primary">
                {nextemi?.dueDate
                  ? new Date(nextemi.dueDate).toLocaleDateString("en-IN")
                  : "N/A"}
              </strong>
            </div>
          </div>
        </div>

        {/* --- न्यू इंप्रूव्ड सेक्शन: आंशिक भुगतान ब्रेकडाउन टेबल --- */}
        {partialPaymentsHistory.length > 0 && (
          <div className="receipt-section">
            <h3 className="receipt-section-title">
              PAYMENT BREAKDOWN (TRANSACTION HISTORY)
            </h3>
            <table className="receipt-breakdown-table">
              <thead>
                <tr>
                  <th>Trx No.</th>
                  <th>Payment Date</th>
                  <th>Payment Mode</th>
                  <th style={{ textAlign: "right" }}>Amount Paid</th>
                </tr>
              </thead>
              <tbody>
                {partialPaymentsHistory.map((pay) => (
                  <tr key={pay.index}>
                    <td>#{pay.index}</td>
                    <td>
                      {pay.date
                        ? new Date(pay.date).toLocaleDateString("en-IN")
                        : "--"}
                    </td>
                    <td>
                      <span className="mode-tag">{pay.mode || "Cash"}</span>
                    </td>
                    <td style={{ textAlign: "right" }}>
                      <strong>₹{pay.amount.toLocaleString("en-IN")}</strong>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}

        <div className="receipt-footer-signs" style={{ marginTop: "40px" }}>
          <div className="receipt-sign-box">
            <div className="receipt-sign-line"></div>
            <p>Authorized Signatory</p>
          </div>
          <div className="receipt-sign-box">
            <div className="receipt-sign-line"></div>
            <p>Customer Signature</p>
          </div>
        </div>

        <p className="receipt-system-gen-text">
          This is a system-generated slip and does not require a physical
          signature.
          <br />
          For any discrepancies, please contact finance desk within 24 working
          hours.
        </p>
      </div>

      {/* Thermal Print Design */}
      <div id="thermal-0" className="thermal-slip-wrapper">
        <div ref={thermalReceiptRef} className="thermal-slip">
          <div className="thermal-company">
            <div className="thermal-company-name">
              {company ? company.name : "--"}
            </div>
            <div className="thermal-company-text">
              <b>Address:</b> {company ? company.address : "--"}
            </div>
            <div className="thermal-company-text">
              <b>Phone:</b> {company ? company.contact : "--"}
            </div>
          </div>

          <div className="thermal-divider"></div>
          <div className="thermal-title">EMI COLLECTION SLIP</div>
          <div className="thermal-row">
            <b>Status:</b> {emi?.status?.toUpperCase()}
          </div>
          <div className="thermal-divider"></div>

          <div className="thermal-row">
            <b>Cust Name:</b> {customerName || emi?.loan?.userName || "--"}
          </div>
          <div className="thermal-row">
            <b>Acc No:</b> {loanNumber || emi?.loan?.loanAccountNumber || "--"}
          </div>
          <div className="thermal-row">
            <b>EMI No:</b> {emi?.emiNumber || "--"}
          </div>

          <div className="thermal-divider"></div>
          <div className="thermal-row">
            <b>EMI Amt:</b> ₹{emi?.emiAmount || "0"}
          </div>
          <div className="thermal-row">
            <b>Penalty:</b> ₹
            {emi?.penaltyAmount === 0
              ? (emi?.penalty || 0).toLocaleString("en-IN")
              : (emi?.penaltyAmount || 0).toLocaleString("en-IN")}
          </div>

          {isPartial && (
            <>
                    <div className="thermal-row font-large">
            <b>Total Paid:</b> ₹{totalPaidTillDate}
          </div>
            <div className="thermal-row text-danger">
              <b>EMI Balance:</b> ₹{emi?.emiBalance || "0"}
            </div>
            </>
          )}
          {isAdvance && (
            <div className="thermal-row">
              <b>Remaining Adv Amount:</b> ₹{unusedAmount}
            </div>
          )}

          {/* Thermal पर भी शॉर्ट हिस्ट्री */}
          {partialPaymentsHistory.length > 0 && (
            <>
              <div className="thermal-divider"></div>
              <div
                style={{
                  fontSize: "11px",
                  fontWeight: "bold",
                  textAlign: "center",
                }}
              >
                PAYMENT HISTORY
              </div>
              {partialPaymentsHistory.map((p) => (
                <div
                  className="thermal-row"
                  style={{ fontSize: "10px" }}
                  key={p.index}
                >
                  <span>
                    Txn#{p.index} ({p.mode || "Cash"}):
                  </span>
                  <strong>₹{p.amount}</strong>
                </div>
              ))}
            </>
          )}

          <div className="thermal-divider"></div>
          <div className="thermal-row">
            <b>Outstanding:</b>₹{remainingOutstanding ?? emi?.outstanding ?? 0}
          </div>
          <div className="thermal-row">
            <b>Next Due:</b>{" "}
            {nextemi?.dueDate
              ? new Date(nextemi.dueDate).toLocaleDateString("en-In")
              : "--"}
          </div>
          <div className="thermal-row">
            <b>Payment Date:</b>{" "}
            {new Date(receiptDate).toLocaleDateString("en-In")}
          </div>

          <div className="thermal-divider"></div>
          <div className="thermal-footer">
            <div>Thank you for your payment!</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Loanemireciept;
